export const GET_USERS = 'GET_USERS';
export const CHANGE_USER_PERMISSIONS = 'CHANGE_USER_PERMISSIONS';
